import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConstantsService } from '../../services/constants.service';
import { FoldersService } from '../../services/folders.service';

@Component({
  selector: 'app-nav-left',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './nav-left.component.html',
  styleUrl: './nav-left.component.css'
})
export class NavLeftComponent implements OnInit {

  isLoading: boolean = false;
  public currentIndex: string | undefined;

  constructor(private folderSvc: FoldersService, public constants: ConstantsService) {
    this.currentIndex = this.constants.indexEHD;
  }

  ngOnInit(): void {
    this.init();
    this.folderSvc.selectedLibrary$.subscribe((l) => {
      this.currentIndex = l;
    });
  }

  init() {
    this.currentIndex = this.folderSvc.getSelectedLibrary();
  }

  switchIndex(indexName: string) {
    this.currentIndex = indexName; // Set the styles
    
    //Change update the selection in the folder Service
    this.folderSvc.setSelectedLibrary(indexName); // Update the index Name
  }
}
